// @ts-nocheck
/*
 * Cyber oct 2026: la Caja 5 de regalo en el carro. Adaptado de ep-regalo-18.js (oferta del 18, que
 * funcionó en la tienda real del 14 al 18-sep).
 *
 * Por qué existe: en 2025 el regalo había que agregarlo a mano y a varios clientes no les llegó. Acá el
 * cliente no hace nada: la caja entra sola al carro y puede cambiar el sabor desde el mismo carro.
 *
 * Reglas (Tomi, 1-oct):
 * - 2 o más Cajas de 20 en el carro = 1 regalo, sin importar el pack (40, 60, 80, Arma tu pack).
 * - Los sabores disponibles y si el regalo sigue vigente los decide ep-cyber.js (fechas e interruptores de
 *   Configuración del tema → Cyber oct 2026). Cupos: Caramelo 100, Choc. Blanco 100, Maní 50, Cacao 50;
 *   cuando un sabor llega a su cupo se apaga su interruptor y sale de acá solo.
 * - El regalo es un producto propio a $0 con una variante por sabor, cada una con el SKU de su Caja 5.
 *   No es un descuento: un "Compra X, llévate Y" le quita el precio de pack a las Cajas de 20 en este
 *   plan de Shopify (probado el 13-sep).
 * - No toca ep-cart-drawer.js: envuelve su render() y su renderItem().
 * - Fuera del Cyber (o con el regalo apagado) saca el regalo de los carros que lo tengan.
 * - Antes de ir al checkout revisa el carro una última vez, y en la página /cart también, porque
 *   Arma tu pack llega directo ahí sin pasar por el carro lateral.
 */
(function () {
  'use strict';

  var REGALO_HANDLE = 'regalo-caja-5-oferta-18';
  var CAJAS_20 = ['49195419336997', '49195418812709', '51994453213477', '51994461634853'];
  var CLAVE_SABOR = 'epRegaloCyberSabor';
  // La Caja 5 real: su precio es lo que vale el regalo. Se lee de Shopify para no escribir el número acá.
  var CAJA5_HANDLE = 'protein-up-caramelo-caja-5-unidades';

  var variantes = null; // [{id, sabor}] en el orden del producto
  var valor = 0; // precio de la Caja 5 en subunidades (x100); 0 mientras no se haya leído
  var sincronizando = false;

  function estado() { return window.EpCyber ? window.EpCyber.estado() : { regalo: false, sabores: [] }; }
  function activa() { return estado().regalo; }
  function esRegalo(item) { return item.handle === REGALO_HANDLE; }
  function fmt(p) { return '$' + Math.round(p / 100).toLocaleString('es-CL'); }

  // Valor del regalo (Tomi, 1-oct: el ahorro del regalo se muestra junto con el del pack). Si la lectura
  // falla, queda en 0 y el carro se ve como sin esta función: nunca un número inventado.
  function valorRegalo() {
    if (valor) return Promise.resolve(valor);
    return fetch('/products/' + CAJA5_HANDLE + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p && p.variants && p.variants[0]) valor = p.variants[0].price || 0; return valor; })
      .catch(function () { return 0; });
  }

  function leerPreferido() { try { return sessionStorage.getItem(CLAVE_SABOR); } catch (e) { return null; } }
  function guardarPreferido(id) { try { sessionStorage.setItem(CLAVE_SABOR, String(id)); } catch (e) {} }

  function contarCajas20(cart) {
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (CAJAS_20.indexOf(String(cart.items[i].variant_id)) !== -1) n += cart.items[i].quantity;
    }
    return n;
  }

  function obtenerVariantes() {
    if (variantes) return Promise.resolve(variantes);
    return fetch('/products/' + REGALO_HANDLE + '.js')
      .then(function (r) { if (!r.ok) throw new Error('regalo no disponible'); return r.json(); })
      .then(function (p) {
        variantes = p.variants.map(function (v) { return { id: v.id, sabor: v.option1 }; });
        return variantes;
      });
  }

  // Las variantes que se pueden elegir hoy, en el orden del selector (el de ep-cyber.js).
  function disponibles() {
    var permitidos = estado().sabores;
    return (variantes || []).filter(function (v) { return permitidos.indexOf(v.sabor) !== -1; })
      .sort(function (a, b) { return permitidos.indexOf(a.sabor) - permitidos.indexOf(b.sabor); });
  }

  function variantePreferida() {
    return obtenerVariantes().then(function () {
      var vs = disponibles();
      if (!vs.length) return null;
      var pref = leerPreferido();
      for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === pref) return vs[i].id;
      return vs[0].id;
    });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  // Deja el carro con 0 o 1 regalo de un sabor permitido. Devuelve true si cambió algo.
  function ajustar(cart) {
    return obtenerVariantes().catch(function () { return null; }).then(function () {
      var permitidas = disponibles().map(function (v) { return String(v.id); });
      var quiero = activa() && permitidas.length && contarCajas20(cart) >= 2 ? 1 : 0;
      var lineas = cart.items.filter(esRegalo);
      var tengo = lineas.reduce(function (s, it) { return s + it.quantity; }, 0);
      // El sabor que corresponde: el último que eligió el cliente si sigue disponible; si no, el que ya
      // tiene en el carro (si está disponible); si no, el primero del selector.
      var pref = leerPreferido();
      var prefOk = permitidas.indexOf(String(pref)) !== -1;
      var quedarse = -1;
      lineas.forEach(function (it, i) {
        var id = String(it.variant_id);
        if (permitidas.indexOf(id) === -1) return;
        if (prefOk ? id === String(pref) : quedarse === -1) quedarse = i;
      });
      var saborOk = lineas.length === 1 && quedarse === 0;
      if (tengo === quiero && lineas.length <= 1 && (quiero === 0 || saborOk)) return false;

      var cadena = Promise.resolve();
      lineas.forEach(function (it, i) {
        var cantidad = (quiero === 1 && i === quedarse) ? 1 : 0;
        if (it.quantity !== cantidad) {
          cadena = cadena.then(function () { return post('/cart/change.js', { id: it.key, quantity: cantidad }); });
        }
      });
      if (quiero === 1 && quedarse === -1) {
        cadena = cadena.then(variantePreferida).then(function (id) {
          if (id) return post('/cart/add.js', { items: [{ id: id, quantity: 1 }] });
        });
      }
      return cadena.then(function () { return true; });
    });
  }

  function leerCarrito() { return fetch('/cart.js').then(function (r) { return r.json(); }); }

  function sincronizar() {
    return leerCarrito().then(function (cart) {
      return ajustar(cart).then(function (cambio) { return cambio ? leerCarrito() : cart; });
    });
  }

  // Con una sola Caja de 20: el mensaje de arriba invita a sumar otra por el regalo (aprobado el 29-sep,
  // prototipo k1-b), y el aviso que ya existe abajo suma la línea del regalo.
  function pintarAvisos(cart) {
    var unaCaja = activa() && cart.items.length > 0 && contarCajas20(cart) === 1 && !cart.items.some(esRegalo);
    var msg = document.getElementById('ep-cart-progress-msg');
    var wrap = document.getElementById('ep-cart-progress-wrap');
    if (msg && unaCaja) {
      var envio = cart.total_price < 4999000;
      msg.innerHTML = 'Súmale <strong>1 caja de 20</strong> y te regalamos una <strong>Caja 5</strong> 🎁'
        + (envio ? ', con envío gratis' : '');
      if (wrap) wrap.removeAttribute('hidden');
    }
    var sub = document.querySelector('#ep-cart-caja20-upsell .ep-cart-drawer__caja20-upsell-sub');
    if (sub) {
      var extra = sub.querySelector('[data-epcy-regalo]');
      if (activa() && !extra) {
        extra = document.createElement('span');
        extra.setAttribute('data-epcy-regalo', '1');
        extra.innerHTML = ' + <strong>Caja 5 de regalo</strong> 🎁';
        sub.appendChild(extra);
      } else if (!activa() && extra) { extra.remove(); }
    }
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function renderRegalo(item) {
    var img = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_100x100$1$2') : '';
    var opciones = disponibles().map(function (v) {
      return '<option value="' + v.id + '"' + (String(v.id) === String(item.variant_id) ? ' selected' : '') + '>' + esc(v.sabor) + '</option>';
    }).join('');
    // Sin link, sin botones de cantidad y sin "Eliminar": el regalo no se toca a mano, solo se cambia el sabor.
    return '<div class="ep-cart-item" data-key="' + item.key + '" data-regalo="1">'
      + '  <div class="ep-cart-item__img-wrap">'
      + (img ? '<img src="' + img + '" alt="" class="ep-cart-item__img" loading="lazy">' : '<div class="ep-cart-item__img-ph"></div>')
      + '  </div>'
      + '  <div class="ep-cart-item__info">'
      + '    <span class="epcy-badge" style="display:inline-block;align-self:flex-start;width:auto;background:#C21B1B;color:#fff;font-size:10px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;border-radius:4px;padding:3px 7px;margin-bottom:4px">🎁 Regalo Cyber</span>'
      + '    <span class="ep-cart-item__title">Caja 5 de regalo</span>'
      + (opciones ? '    <select class="epcy-sel" data-regalo-select aria-label="Sabor de tu Caja 5 de regalo" style="margin:6px 0 0;max-width:100%">' + opciones + '</select>'
        : '    <p class="ep-cart-item__variant">Sabor: ' + esc(item.variant_title || '') + '</p>')
      + '    <div class="ep-cart-item__bottom">'
      + '      <div></div>'
      + '      <div class="ep-cart-item__prices"><span class="ep-cart-item__price ep-cart-item__price--sale" style="color:#1F8A3B;font-weight:800">Gratis</span>'
      + (valor ? '<span class="ep-cart-item__price ep-cart-item__price--original">' + fmt(valor) + '</span>' : '') + '</div>'
      + '    </div>'
      + '  </div>'
      + '</div>';
  }

  function instalar() {
    var D = window.EpCartDrawer;
    if (!D || D.__regaloCyber) return false;
    D.__regaloCyber = true;

    var renderOriginal = D.render.bind(D);
    var renderItemOriginal = D.renderItem.bind(D);

    D.renderItem = function (item) {
      return esRegalo(item) ? renderRegalo(item) : renderItemOriginal(item);
    };

    // La línea "Ahorras" suma el valor del regalo al descuento del pack cuando la Caja 5 está en el carro.
    function pintarAhorro(cart) {
      if (!valor || !cart.items.some(esRegalo)) return;
      var amt = document.getElementById('ep-cart-savings-amt');
      var box = document.getElementById('ep-cart-savings');
      if (!amt || !box) return;
      amt.textContent = fmt((cart.total_discount || 0) + valor);
      box.removeAttribute('hidden');
    }

    // Cupón de Mercado Pago (opción 2, Tomi, 4-oct): mini ticket sobre "Ahorras", solo mientras haya
    // cupones y con el carro en $30.000 o más, que es la compra mínima del cupón.
    function pintarMP(cart) {
      var box = document.getElementById('epcy-mp-carro');
      var e = window.EpCyber ? window.EpCyber.estado() : {};
      var ver = !!e.mp && cart.item_count > 0 && cart.total_price >= 3000000;
      if (!ver) { if (box) box.hidden = true; return; }
      if (!box) {
        var ancla = document.getElementById('ep-cart-savings');
        if (!ancla || !ancla.parentNode) return;
        var cfg = window.EP_CYBER_CFG || {};
        box = document.createElement('div');
        box.id = 'epcy-mp-carro';
        box.className = 'epcy-mpc';
        box.innerHTML = '<div class="epcy-mpc__tal"><img src="' + cfg.mpLogo + '" alt="Mercado Pago"></div>'
          + '<div class="epcy-mpc__cu"><div class="epcy-mpc__v">+ $5.000 de descuento</div>'
          + '<div class="epcy-mpc__s">Con dinero en tu cuenta Mercado Pago</div>'
          + '<div class="epcy-mpc__cod">Código <span class="epcy-cod epcy-cod--sm">CYBERMP</span></div>'
          + '<a class="epcy-mpc__a" href="' + (cfg.mpUrl || '/pages/cupon-cybermp') + '">¿Cómo se usa? →</a></div>';
        ancla.parentNode.insertBefore(box, ancla);
      }
      box.hidden = false;
    }

    function pintar(cart) {
      renderOriginal(cart);
      pintarAvisos(cart);
      pintarMP(cart);
      // La primera vez el valor puede no estar leído todavía: se lee y se repinta solo el ahorro y el tachado.
      if (valor) { pintarAhorro(cart); return; }
      if (!cart.items.some(esRegalo)) return;
      valorRegalo().then(function (v) { if (v && !D._busy) { renderOriginal(cart); pintarAvisos(cart); pintarAhorro(cart); } });
    }

    D.render = function (cart) {
      pintar(cart);
      if (sincronizando) return;
      sincronizando = true;
      D._busy = true;
      ajustar(cart)
        .then(function (cambio) { return cambio ? leerCarrito() : (variantes && cart.items.some(esRegalo) ? cart : null); })
        .then(function (nuevo) {
          D._busy = false;
          sincronizando = false;
          if (nuevo) pintar(nuevo);
        })
        .catch(function () { D._busy = false; sincronizando = false; });
    };

    // Cambio de sabor del regalo: se saca la línea actual y se agrega la variante elegida.
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-regalo-select]');
      if (!sel || D._busy) return;
      var itemEl = sel.closest('[data-key]');
      var nuevoId = sel.value;
      if (!itemEl) return;
      D._busy = true;
      sincronizando = true;
      itemEl.classList.add('ep-cart-item--loading');
      guardarPreferido(nuevoId);
      post('/cart/change.js', { id: itemEl.getAttribute('data-key'), quantity: 0 })
        .then(function () { return post('/cart/add.js', { items: [{ id: Number(nuevoId), quantity: 1 }] }); })
        .then(leerCarrito)
        .then(function (cart) { D._busy = false; sincronizando = false; D.render(cart); })
        .catch(function () { D._busy = false; sincronizando = false; D.refresh(); });
    }, true);

    // Red de seguridad al pagar: se revisa el carro una última vez antes de ir al checkout.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#ep-cart-checkout-btn');
      if (!btn) return;
      e.preventDefault();
      btn.style.opacity = '0.6';
      sincronizar()
        .catch(function () {})
        .then(function () { window.location.href = btn.getAttribute('href') || '/checkout'; });
    }, true);

    // Si cambia el tramo o un interruptor mientras la página está abierta (por ejemplo, a medianoche).
    document.addEventListener('epcyber:cambio', function () { if (!D._busy) D.refresh(); });

    return true;
  }

  // Página /cart: Arma tu pack llega acá directo. Se ajusta y, si cambió algo, se recarga una vez.
  function enPaginaCarro() {
    if (location.pathname.replace(/\/$/, '') !== '/cart') return;
    // Una sola recarga: si después de recargar el carro todavía no cuadra, no se insiste.
    leerCarrito().then(ajustar).then(function (cambio) {
      var ya = false;
      try { ya = sessionStorage.getItem('epCyCartRecarga') === '1'; } catch (e) {}
      if (!cambio) { try { sessionStorage.removeItem('epCyCartRecarga'); } catch (e) {} return; }
      if (ya) return;
      try { sessionStorage.setItem('epCyCartRecarga', '1'); } catch (e) {}
      location.reload();
    }).catch(function () {});
  }

  // Selectores de sabor fuera del carro (páginas de pack): muestran solo los sabores disponibles y
  // guardan la elección, que el carro usa al agregar el regalo.
  function poblarSelectores() {
    var sels = document.querySelectorAll('[data-epcy-sabor]');
    if (!sels.length) return;
    obtenerVariantes().then(function () {
      var vs = disponibles();
      var pref = leerPreferido();
      var elegido = vs.some(function (v) { return String(v.id) === pref; }) ? pref : (vs[0] ? String(vs[0].id) : '');
      sels.forEach(function (sel) {
        sel.innerHTML = vs.map(function (v) {
          return '<option value="' + v.id + '"' + (String(v.id) === elegido ? ' selected' : '') + '>' + esc(v.sabor) + '</option>';
        }).join('');
        if (!sel.__epcy) {
          sel.__epcy = true;
          sel.addEventListener('change', function () {
            guardarPreferido(sel.value);
            document.querySelectorAll('[data-epcy-sabor]').forEach(function (o) { o.value = sel.value; });
          });
        }
      });
    }).catch(function () {});
  }
  document.addEventListener('epcyber:cambio', poblarSelectores);

  document.addEventListener('DOMContentLoaded', function () {
    if (activa()) valorRegalo();
    poblarSelectores();
    enPaginaCarro();
    // ep-cart-drawer.js se inicializa en su propio DOMContentLoaded; se reintenta hasta que exista.
    var intentos = 0;
    (function esperar() {
      if (instalar() || intentos++ > 40) return;
      setTimeout(esperar, 50);
    })();
  });

  // El selector del regalo en las páginas de pack guarda acá el sabor elegido.
  window.EpRegaloCyber = { guardarPreferido: guardarPreferido, leerPreferido: leerPreferido, obtenerVariantes: obtenerVariantes, disponibles: disponibles };
})();
